import {useContext, useEffect} from "react";
import {Form, Input, Button, Select, Space, Col, Row, ConfigProvider, Modal} from "antd";
import {MinusCircleOutlined, PlusOutlined, InfoCircleOutlined, CloseOutlined} from "@ant-design/icons";
import {SDrawerOrModal, STitle} from "shj-components";
import {isEmpty} from "lodash-es";
import measureContext from "@/pages/roomMeasurementTools/roomMeasurementManage/modal/AddOrEditSteps/measureContext.ts";
import {typeKeyEnum} from "./typeEnum.ts";
import styles from '../../modal/AddOrEditSteps/index.module.less'
import {useSetState} from "ahooks";

export const EditStepForm = (props) => {
  const {type} = props;
  const {measureRoomConfig} = useContext(measureContext)
  const [form] = Form.useForm()
  const optionsObj = measureRoomConfig[type]
  const [state, setState] = useSetState({
    open: false,
    img: ''
  })

  useEffect(() => {
    if (!isEmpty(props.data)) {
      if (typeKeyEnum[type].dataKey) {
        form.setFieldsValue({[typeKeyEnum[type].dataKey]: props.data})
      } else {
        form.setFieldsValue(props.data?.[0] || {})
      }
    }
  }, [props.data]);

  const getFormItems = (formName?) => {
    const data = typeKeyEnum[type].formConfig
    return data.map(item => {
      let name = item.name
      if (formName !== undefined) {
        name = [formName, item.name]
      }
      const formItem = (
          <Form.Item label={item.label} name={name} hidden={item.hidden}>
            {item.type === 'select' ?
                <Select placeholder={`请选择`} options={optionsObj[item.name + 'Data']} fieldNames={{value: 'key', label: 'label'}} labelInValue/> :
                <Input placeholder={`请输入`} {...item.comConfig}/>}
          </Form.Item>
      )
      return item.hidden ? formItem : <Col span={item.hidden ? 0 : 6}>
        {formItem}
      </Col>
    })
  }

  const getDataSource = () => {
    const values = form.getFieldsValue();
    const { dataKey, formConfig } = typeKeyEnum[type];

    // 获取原始数据源
    const dataSource = dataKey ? values[dataKey] : [values];

    if(dataSource?.length < 0) return [];
    // 构建 formConfig 映射表
    const formConfigMap = formConfig.reduce((map, config) => {
      map[config.name] = config;
      return map;
    }, {} as Record<string, typeof formConfig[number]>);

    // 处理数据源中的每个字段
    return dataSource?.map(item => {
      const newItem = {...item}; // 保持原数据不可变
      for (const key in item) {
        if (formConfigMap[key]?.type === 'select' && typeof newItem[key] === 'object' ) {
          newItem[key] = item[key]?.key ?? '';
          newItem[`${key}Name`] = item[key]?.label ?? '';
        }
      }
      return newItem;
    });
  };

  if (props.tableRef) {
    props.tableRef[type] = {
      getDataSource
    }
  }

  const onOpenTipModal = (img) => {
    setState({open: true, img})
  }

  return <>
    <STitle title={<>{typeKeyEnum[type]?.title}
      <InfoCircleOutlined style={{marginLeft: 6, fontSize: 12}} onClick={() => onOpenTipModal(typeKeyEnum[type]?.exampleImg)}/>
    </>} titleMode={'edit'}/>
    <div className={styles.editTable}>
      <Form layout={'vertical'} form={form}>
        {typeKeyEnum[type].dataKey ? <Form.List name={typeKeyEnum[type].dataKey}>
              {(fields, {add, remove}) => (
                  <>
                    {fields.map(({key, name}) => (
                        <Row gutter={5} key={key}>
                          <div className={styles.formListItem}>
                            <Col span={1}><MinusCircleOutlined onClick={() => remove(name)}
                                                               style={{marginRight: 10, marginTop: 5, color: 'red'}}/></Col>
                            <Col span={23}>
                              <Row gutter={5}>{getFormItems(name)}</Row>
                            </Col>
                          </div>
                        </Row>
                    ))}
                    <Form.Item>
                      <Button block onClick={() => add()} icon={<PlusOutlined/>}>
                        新增
                      </Button>
                    </Form.Item>
                  </>
              )}
            </Form.List> :
            <Row gutter={10}> {getFormItems()}</Row>
        }
      </Form>
    </div>

    <Modal
      width={1000}
      title={' '}
      open={state.open}
      footer={null}
      closable={false}
      wrapClassName={styles.qualityModalWrap}
    >
      <div style={{position: 'relative', fontSize: 0, backgroundColor: '#fff'}}>
        <img src={typeKeyEnum[type]?.exampleImg} alt={typeKeyEnum[type]?.title} style={{width: 1000, height: 'auto'}}/>
        <CloseOutlined style={{position: 'absolute', top: 20, right: 20, fontSize: 20, cursor: 'pointer', color: '#9a9a9a'}} onClick={() => setState({open: false})}/>
      </div>
    </Modal>
  </>
}